import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function ArrowDown(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M0.451647 6.05165C1.05384 5.44945 2.03017 5.44945 2.63229 6.05165L11.8219 15.2412L21.0116 6.05165C21.6137 5.44945 22.5902 5.44945 23.1923 6.05165C23.7945 6.65384 23.7945 7.63017 23.1923 8.23229L12.9123 18.5123C12.3101 19.1145 11.3338 19.1145 10.7316 18.5123L0.451647 8.23229C-0.150545 7.63011 -0.150545 6.65376 0.451647 6.05165V6.05165Z"
  }));
}

export { ArrowDown };
//# sourceMappingURL=ArrowDown.js.map